export const headers = [
  { name: 'Tipo', field: 'menu_food_type.name', sortable: true },
  { name: 'Instituições', field: 'institutions_list', sortable: true },
  { name: 'Ativo', field: 'is_active', sortable: true },
  { name: 'Cadastrado em', field: 'created_at', sortable: false },
  { name: 'Ações', field: 'actions', sortable: false }
]

export const headerMenuDishes = [
  { name: 'Data', field: 'date', sortable: true },
  { name: 'Itens', field: 'menu_dishes', sortable: true },
  {
    name: 'Cadastrado em',
    field: 'created_at',
    sortable: false
  },
  { name: 'Ações', field: 'actions', sortable: false }
]

export const headerMenuInstitutions = [
  {
    name: 'Nome Fantasia',
    field: 'institution.company_social_name',
    sortable: true
  },
  { name: 'CNPJ', field: 'institution.cnpj', sortable: false },
  { name: 'Telefone', field: 'institution.phone', sortable: false },
  {
    name: 'Ativo',
    field: 'institution.is_active',
    sortable: false
  },
  { name: 'Cadastrado em', field: 'created_at', sortable: false },
  { name: 'Ações', field: 'actions', sortable: false }
]
